import script from "./EngagementIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./EngagementIcon.vue?vue&type=script&setup=true&lang=js"

import "./EngagementIcon.vue?vue&type=style&index=0&id=cbf0641c&scoped=true&lang=css"

import exportComponent from "/Users/jwmoreland/Documents/_Develop/HIRC Website/wp-content/themes/hirc-custom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbf0641c"]])

export default __exports__